import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import { IUserInfo } from 'common/interface/props';
import { axiosCustom } from 'common/common.function';
import Presenter from 'components/UI/organisms/Header/Presenter';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  // solType
  const [solType, setSolType] = useState('');

  // 로그인 여부
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // 로그인 여부 체크 (주소가 바뀔때마다)
  useEffect(() => {
    // WakeUp 서비스 확인
    setSolType(
      ['WEMAKEPRICE', `ADMIN`, `COUPANG`, 'ST11', 'KAKAO', 'ALWAYZ', 'ALL'].includes(location.pathname.split('/')[1].toUpperCase())
        ? location.pathname.split('/')[1].toUpperCase()
        : '',
    );

    // 로그인 정보 가져오기
    const rawUserInfo = sessionStorage.getItem('userInfo');

    // 로그인 데이터 파싱
    const userInfo: IUserInfo = rawUserInfo && JSON.parse(rawUserInfo);

    userInfo ? setIsLoggedIn(true) : setIsLoggedIn(false);
  }, [location]);

  // useEffect(() => {
  //   if (location.pathname !== '/coupang/admin' && solType === 'COUPANG') {
  //     window.location.href = 'https://engapi-coupang.playauto.co.kr';
  //   }
  // }, [solType]);

  // 로그아웃
  async function checkLogout() {
    const confirm = await Swal.fire({
      title: '확인',
      text: '로그아웃하시겠습니까?',
      showConfirmButton: true,
      showCancelButton: true,
    });

    if (confirm.isConfirmed) {
      //Cookie에 jwt Token 삭제 API 호출
      const logoutResult = await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/member/logout`);

      if (logoutResult.success) {
        setIsLoggedIn(false);

        sessionStorage.removeItem('userInfo'); //로그인 정보 세션스토리지 초기화
        navigate(`/${solType.toLowerCase()}/member/create-account`); //router init
      }
    }
  }

  return <Presenter checkLogout={checkLogout} solType={solType} isLoggedIn={isLoggedIn} />;
}
